import { navLinks } from '@/mocks/home';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-closed-captioning-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                中文在线字幕
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">
              聚合中文在线字幕官方平台入口、最新地址与 app 下载方式的信息整理页面，
              帮助用户解决找不到网址、打不开页面的问题。本页不代表官方运营，所有服务以官方平台为准。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">
              页面导航
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-2.5 gap-x-4">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-secondary-200 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">
              重要说明
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li className="flex items-start gap-2 text-sm text-secondary-200">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-400"></i>
                <span>本页不托管任何视频内容</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-secondary-200">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-400"></i>
                <span>入口与地址以官方公告为准</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-secondary-200">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-400"></i>
                <span>下载请选择官方发布来源</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-secondary-800 pt-6">
          <p className="text-xs md:text-sm text-secondary-300">
            © {year} 中文在线字幕免费高清 · 信息整理页面
          </p>
          <p className="text-xs md:text-sm text-secondary-300">
            谨慎辨别入口 · 注意账号与设备安全
          </p>
        </div>
      </div>
    </footer>
  );
}